import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles.css';

if (window.self !== window.top) {
  document.documentElement.classList.add('in-frame');
}

/**
 * Samsung PWA often keeps a ~980–1080 CSS-px layout viewport (desktop density).
 * Stretching to that width makes type unreadable. Layout as a 390px phone,
 * then zoom up so it fills the physical screen.
 */
const PHONE_LAYOUT_PX = 390;

function applyPhoneLayout() {
  const touch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
  const shortSide = Math.min(screen.width, screen.height);
  const tall = window.innerHeight > window.innerWidth * 1.15;
  if (!touch || !(shortSide <= 600 || tall)) return;

  const html = document.documentElement;
  html.classList.add('phone');

  document.querySelectorAll('meta[name="viewport"]').forEach((el) => el.remove());
  const meta = document.createElement('meta');
  meta.name = 'viewport';
  meta.content = `width=${PHONE_LAYOUT_PX}, initial-scale=1, viewport-fit=cover`;
  document.head.prepend(meta);

  const layoutWidth = () => window.visualViewport?.width ?? window.innerWidth;

  const scaleToScreen = () => {
    const vw = layoutWidth();
    if (vw <= 480) {
      html.style.zoom = '';
      html.style.width = '';
      return;
    }
    html.style.width = `${PHONE_LAYOUT_PX}px`;
    html.style.zoom = String(vw / PHONE_LAYOUT_PX);
  };

  scaleToScreen();
  requestAnimationFrame(scaleToScreen);
  window.addEventListener('resize', scaleToScreen);
  window.visualViewport?.addEventListener('resize', scaleToScreen);
}

applyPhoneLayout();

const root = document.getElementById('root');
if (!root) throw new Error('Element #root nenalezen');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
